import settings from './settings';

const envSettings = settings.getSettings();
console.log('ENVIRONMENT:', envSettings.name);
console.log('SETTINGS:', envSettings);
export default envSettings;
